module.exports = __webpack_public_path__ + "static/media/15.google-drive.7ebf29ff.svg";